// extracted by mini-css-extract-plugin
module.exports = {"container":"_105329b597--container--x6FgC","delete":"_105329b597--delete--WNa8v"};